let config = {
  zmlgw: '/zmlAPI',
  hlwAPI: '/hlwAPI',
};
config.share = {
  // title: '脂玫乐-1对1健康瘦身;专业减肥瘦身网站',
  description: '脂玫乐-1对1健康瘦身;专业减肥瘦身网站',
  // url: 'https://www.zmelo.com/',
  // source: 'https://www.zmelo.com/',
  // image: 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/wxewm.png',
  sites: ['qzone', 'qq', 'weibo', 'wechat', ], // 启用的站点
  disabled: ['google', 'facebook', 'twitter', ], // 禁用的站点
  wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
  wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
};
module.exports = config;



// WEBPACK FOOTER //
// src/others/interface.js